import { UI } from "../data/content";
import { Reveal, HeroBand, SectionHead, ContactModule, usePageMeta } from "../components/kit";

export default function AboutUs() {
  const T = UI.pages.about;
  usePageMeta(T.metaTitle, T.metaDesc);
  return (
    <div data-testid="about-page">
      <HeroBand image="skyline" eyebrow={T.eyebrow} title={T.title}
        standfirst={T.standfirst} compact testId="about-hero" />

      <section className="k-section !pb-10">
        <div className="k-container">
          <Reveal className="max-w-4xl">
            <p className="text-lg leading-relaxed mb-5">{T.intro[0]}</p>
            <p className="text-lg leading-relaxed mb-5">{T.intro[1]}</p>
            <p className="text-lg leading-relaxed text-ink-muted">{T.intro[2]}</p>
          </Reveal>
        </div>
      </section>

      <section className="k-section !py-14 bg-paper-alt" data-testid="how-we-work-section">
        <div className="k-container">
          <SectionHead eyebrow={T.approachEyebrow} title={T.approachTitle} />
          <div className="grid md:grid-cols-3 gap-8">
            {T.principles.map(([title, body], i) => (
              <Reveal key={title} delay={i * 0.06}>
                <div className="border-t-2 border-[var(--accent)] pt-5">
                  <h3 className="text-base font-semibold mb-3">{title}</h3>
                  <p className="text-sm text-ink-muted leading-relaxed">{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="k-section !py-14">
        <div className="k-container">
          <Reveal>
            <SectionHead eyebrow={T.entityEyebrow} title={T.entityTitle} />
            <p className="text-sm text-ink-muted" style={{ fontVariantNumeric: "tabular-nums" }} data-testid="about-company-details">
              {T.entityLine}
            </p>
            <p className="text-sm text-ink-muted mt-2" data-testid="about-reg-office">{T.regOffice}</p>
          </Reveal>
        </div>
      </section>

      <section className="k-container pb-20">
        <ContactModule />
      </section>
    </div>
  );
}
